// extracted by mini-css-extract-plugin
export default {"heroSection":"Hero_heroSection__j-oan"};